import React, { useMemo, useState, useEffect, useRef } from "react";
import axios from "axios";
import {
    ArrowDownRight, ArrowRight, CalendarCheck, Check, ChevronDown,
    Clock3, MessageCircle, PhoneCall, ShoppingCart, Star, Users, Zap
} from "lucide-react";
import "../styles/OpExEngage.css";

const RED = "#E60728";
const TIDYCAL_URL = "https://tidycal.com/dbenson";
function DemoForm() {
    const [form, setForm] = useState({
        name: "", email: "", phone: "", website: "", list_size: "", has_phone_numbers: "",
        software: "", goal: ""
    });
    const [submitted, setSubmitted] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const update = (e) => setForm({ ...form, [e.target.name]: e.target.value });
    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

			if (!API_BASE_URL) {
			  throw new Error("REACT_APP_BACKEND_URL is not configured");
			}

			await axios.post(`${API_BASE_URL}/api/engage-demo`, form);
            setSubmitted(true);
        } catch (err) {
            setError(err?.response?.data?.detail || "We could not submit the form. Please try again or email info@opexcellence.hk.");
        } finally {
            setBusy(false);
        }
    };
    return (
        <section className="oe-section oe-booking-section" id="book-demo">
            <div className="oe-wrap oe-booking-grid">
                <div className="oe-booking-copy">
                    <div className="oe-eyebrow">BOOK A DEMO</div>
                    <h2>Book your OpEx Engage demo</h2>
                    <p>Tell us a little about your business. We will prepare a relevant walkthrough and pilot discussion.</p>
                    <div className="oe-booking-note"><Check size={17} /><span>We use your information to prepare your demo and build a relevant pilot. No spam.</span></div>
                </div>
                <div className="oe-form-card">
                    {!submitted ? (
                        <form onSubmit={submit}>
                            <div className="oe-form-grid">
                                <div className="oe-field"><label htmlFor="oe-name">Full Name *</label><input id="oe-name" name="name" value={form.name} onChange={update} required maxLength="120" autoComplete="name" /></div>
                                <div className="oe-field"><label htmlFor="oe-email">Email *</label><input id="oe-email" name="email" type="email" value={form.email} onChange={update} required autoComplete="email" maxLength="254" /></div>
                                <div className="oe-field"><label htmlFor="oe-phone">Phone *</label><input id="oe-phone" name="phone" type="tel" value={form.phone} onChange={update} required autoComplete="tel" maxLength="40" /></div>
                                <div className="oe-field"><label htmlFor="oe-website">Website (We use this to build the bot!) *</label><input id="oe-website" name="website" type="url" placeholder="https://" value={form.website} onChange={update} required maxLength="300" /></div>
                                <div className="oe-field"><label htmlFor="oe-list-size">How big is your email list? *</label><select id="oe-list-size" name="list_size" value={form.list_size} onChange={update} required><option value="">Choose a range</option><option>Under 1,000</option><option>1,000–5,000</option><option>5,000–20,000</option><option>20,000+</option></select></div>
                                <div className="oe-field"><label htmlFor="oe-phone-list">Do you have phone numbers of the contacts? *</label><select id="oe-phone-list" name="has_phone_numbers" value={form.has_phone_numbers} onChange={update} required><option value="">Choose one</option><option>Yes</option><option>Partial</option><option>No</option></select></div>
                                <div className="oe-field oe-field-full"><label htmlFor="oe-software">What software are you currently using for outreach and lead management? *</label><textarea id="oe-software" name="software" value={form.software} onChange={update} required maxLength="2000" rows="3" /></div>
                                <div className="oe-field oe-field-full"><label htmlFor="oe-goal">What’s the number 1 thing you would like to gain from working with OpEx Engage? *</label><textarea id="oe-goal" name="goal" value={form.goal} onChange={update} required maxLength="2000" rows="3" /></div>
                            </div>
                            {error && <p className="oe-form-error" role="alert">{error}</p>}
                            <button className="oe-btn oe-btn-primary oe-submit" type="submit" disabled={busy}>{busy ? "Submitting…" : "Continue to calendar"} <ArrowRight size={16} /></button>
                            <p className="oe-privacy">We use the information only to prepare your demo and build a relevant pilot. No spam.</p>
                        </form>
                    ) : (
                        <div className="oe-thanks">
                            <div className="oe-thanks-icon"><Check size={22} /></div>
                            <h3>Thank you. Your details have been sent.</h3>
                            <p>Choose a suitable time below to complete your booking.</p>
                            <a className="oe-btn oe-btn-primary" href={TIDYCAL_URL} target="_blank" rel="noreferrer">Open booking calendar <ArrowRight size={16} /></a>
                            <div className="oe-tidycal">
                                <iframe title="Book an OpEx Engage demo" src={TIDYCAL_URL} loading="lazy" />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

export default function OpExEngage() {
    const scrollToBooking = () => document.getElementById("book-demo")?.scrollIntoView({ behavior: "smooth", block: "start" });
    const scrollToOffer = () => document.getElementById("lead-reactivation")?.scrollIntoView({ behavior: "smooth", block: "start" });
    return (
        <main className="oe-page">
            <DemoForm />
        </main>
    );
}
